import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bg-secondary absolute left-0 rounded-r w-1 h-full"
}
const _hoisted_2 = {
  key: 1,
  class: "font-semibold text-sm"
}
const _hoisted_3 = {
  key: 0,
  class: "bg-secondary absolute -left-6 rounded-r w-1 h-full"
}
const _hoisted_4 = {
  key: 1,
  class: "font-semibold text-sm"
}
const _hoisted_5 = { class: "absolute bottom-0 left-0 pointer-events-none group-hover:pointer-events-auto" }
const _hoisted_6 = {
  key: 0,
  class: "font-semibold text-sm"
}

import { computed, ref } from "vue";
import { useStore } from "@/store";
import { menuRoutes } from "@/router";
import { useRoute } from "vue-router";
import AIcon from "@ai-nc/a-components/src/components/media/AIcon.vue";
import ContactModal from "@/components/ContactModal.vue";
import AButton from "@ai-nc/a-components/src/components/button/AButton.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'MenuWrapper',
  setup(__props) {

const store = useStore();
const route = useRoute();

const contactActive = ref(false);

const isWide = computed(() => {
  return true;
  // return store.state.viewWidth > 1000;
});

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['flex w-full max-w-[100vw] min-h-screen overflow-x-clip', _unref(isWide) ? 'pl-52' : 'pl-20'])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([
        'bg-black flex flex-col py-16 fixed left-0 top-0 h-screen justify-between z-50',
        _unref(isWide) ? 'w-52' : 'w-20',
      ])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(['flex flex-col w-full gap-9', _unref(isWide) ? '' : ''])
      }, [
        _createVNode(_component_RouterLink, {
          to: "/",
          class: _normalizeClass(['flex items-center gap-4 w-full mb-11', _unref(isWide) ? 'pl-6' : 'justify-center'])
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              class: _normalizeClass(['h-7', _unref(isWide) ? '' : '']),
              src: "/images/branding/color-no-text.svg"
            }, null, 2),
            (_unref(isWide))
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: _normalizeClass(['h-3', _unref(isWide) ? '' : '']),
                  src: "/images/branding/white-text.svg"
                }, null, 2))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["class"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menuRoutes).top, (link) => {
          return (_openBlock(), _createBlock(_component_RouterLink, {
            key: link.name,
            to: link.path,
            class: _normalizeClass([
            'w-full flex items-center relative h-8 gap-4 p-1',
            _unref(isWide) ? 'pl-6' : 'justify-center',
            _unref(route).path === link.path ? 'text-secondary' : 'text-white',
          ])
          }, {
            default: _withCtx(() => [
              (_unref(route).path === link.path)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1))
                : _createCommentVNode("", true),
              _createVNode(AIcon, {
                icon: link.icon,
                class: _normalizeClass(['h-6 w-6', _unref(isWide) ? '' : '']),
                solid: true
              }, null, 8, ["icon", "class"]),
              (_unref(isWide))
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(link.name), 1))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["to", "class"]))
        }), 128))
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(['flex flex-col w-full gap-9', _unref(isWide) ? '' : ''])
      }, [
        _createElementVNode("div", null, [
          _createVNode(AButton, {
            label: "Give Feedback",
            class: "mx-6",
            size: "small",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (contactActive.value = true))
          }),
          _createVNode(ContactModal, {
            modelValue: contactActive.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((contactActive).value = $event))
          }, null, 8, ["modelValue"])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menuRoutes).bottom, (link) => {
          return (_openBlock(), _createElementBlock("div", {
            key: link.name,
            class: _normalizeClass([
            'w-full flex items-center relative h-8 group',
            _unref(isWide) ? 'pl-6' : 'justify-center',
            _unref(route).path === link.path ? 'text-secondary' : 'text-white',
          ])
          }, [
            _createVNode(_component_RouterLink, {
              to: link.path,
              class: "relative w-full h-full flex gap-4 p-1 z-10"
            }, {
              default: _withCtx(() => [
                (_unref(route).path === link.path)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3))
                  : _createCommentVNode("", true),
                _createVNode(AIcon, {
                  icon: link.icon,
                  class: _normalizeClass(['h-6 w-6', _unref(isWide) ? '' : '']),
                  solid: true
                }, null, 8, ["icon", "class"]),
                (_unref(isWide))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(link.name), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["to"]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", {
                class: _normalizeClass([
                'py-4 bg-black rounded opacity-0 group-hover:opacity-100 transition-all delay-100 duration-75',
                _unref(isWide) ? 'ml-56' : 'ml-24',
              ])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(link.subItems, (subLink) => {
                  return (_openBlock(), _createBlock(_component_RouterLink, {
                    key: subLink.name,
                    to: subLink.path,
                    class: _normalizeClass([
                  'w-full flex items-center relative h-8 gap-4 px-6 py-2',
                  subLink.color ? subLink.color : _unref(route).fullPath === subLink.path ? 'text-secondary' : 'text-white',
                ])
                  }, {
                    default: _withCtx(() => [
                      _createVNode(AIcon, {
                        icon: subLink.icon,
                        class: _normalizeClass(['h-6 w-6']),
                        solid: true
                      }, null, 8, ["icon"]),
                      (_unref(isWide))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(subLink.name), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["to", "class"]))
                }), 128))
              ], 2)
            ])
          ], 2))
        }), 128))
      ], 2)
    ], 2),
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})